import { render } from "./index.vue?vue&type=template&id=2665560a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=2665560a&lang=scss"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vab/components/VabNotice/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2665560a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2665560a', __exports__)) {
    api.reload('2665560a', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=2665560a", () => {
    api.rerender('2665560a', render)
  })

}


export default __exports__